import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { PRICING, PLAN_CHECKLIST } from '../data/pricingContent';
import monthlyBillingIcon from '../../../../assets/pricing/monthly_billing.svg';
import annualBillingIcon from '../../../../assets/pricing/annual_billing.svg';
import tickIcon from '../../../../assets/pricing/tick.svg';

const PlanSelectionCard = ({ onSubscribe, pricing = PRICING }) => {
  const [billingCycle, setBillingCycle] = useState('monthly');
  const isAnnual = billingCycle === 'annual';
  const price = isAnnual ? pricing.annual : pricing.monthly;

  return (
    <Box
      sx={{
        border: '1.5px solid #D13C3C',
        borderRadius: 3,
        boxShadow: '0px 1px 20px #00000029',
        p: { xs: 2.5, md: 2, lg: 2 },
        backgroundColor: '#FFFFFF',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          borderBottom: '1px solid  #D8D8D8',
        }}
      >
        <Typography sx={{ fontSize: { xs: 19, lg: 20 }, fontWeight: 700, color: '#1C2333', mb: 0.3 }}>
          Complete family preparedness
        </Typography>
        <Typography sx={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, color: '#D13C3C', pb: 2 }}>
          ONE PLAN · EVERYTHING YOUR FAMILY NEEDS
        </Typography>
      </Box>

      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <Typography sx={{ fontSize: 15, color: '#202020', textAlign: 'center', mb: 2, mt: 2 }}>
          Pick monthly or yearly billing.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            border: '1.5px solid #D13C3C',
            borderRadius: '50px',
            p: 0.5,
            mb: 2.5,
          }}
        >
          <Box
            onClick={() => setBillingCycle('monthly')}
            sx={{
              flex: 1,
              textAlign: 'center',
              borderRadius: 999,
              py: 1.25,
              px: 1,
              cursor: 'pointer',
              backgroundColor: !isAnnual ? '#D13C3C' : 'transparent',
            }}
          >
            <Typography sx={{ fontSize: 15, fontWeight: 700, color: !isAnnual ? '#fff' : '#1A1A1A' }}>
              Monthly Plan
            </Typography>
            <Typography sx={{ fontSize: 11.5, fontWeight: 500, color: !isAnnual ? 'rgba(255,255,255,0.85)' : '#8F8F8F', mt: 0.25 }}>
              Maximum flexibility
            </Typography>
          </Box>
          <Box
            onClick={() => setBillingCycle('annual')}
            sx={{
              flex: 1,
              textAlign: 'center',
              borderRadius: 999,
              py: 1.25,
              px: 1,
              cursor: 'pointer',
              backgroundColor: isAnnual ? '#D13C3C' : 'transparent',
            }}
          >
            <Typography sx={{ fontSize: 15, fontWeight: 700, color: isAnnual ? '#fff' : '#1A1A1A' }}>
              Annual Plan
            </Typography>
            <Typography sx={{ fontSize: 11.5, mt: 0.25 }}>
              {isAnnual ? (
                <>
                  <Box component="span" sx={{ fontWeight: 500, color: 'rgba(255,255,255,0.85)' }}>Best Value - </Box>
                  <Box component="span" sx={{ fontWeight: 700, color: '#fff', fontSize: '16px' }}>Save ${pricing.annualSavings}</Box>
                </>
              ) : (
                <>
                  <Box component="span" sx={{ color: '#8F8F8F' }}>Best Value - </Box>
                  <Box component="span" sx={{ fontWeight: 700, color: '#1A1A1A' }}>Save </Box>
                  <Box component="span" sx={{ fontWeight: 700, color: '#D13C3C', fontSize: '18px' }}>${pricing.annualSavings}</Box>
                </>
              )}
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            textAlign: 'center',
            mb: 2.5,
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              backgroundColor: '#FDEAEA',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 1.5,
            }}
          >
            <Box
              component="img"
              src={isAnnual ? annualBillingIcon : monthlyBillingIcon}
              alt=""
            />
          </Box>
          <Typography sx={{ fontSize: 14, fontWeight: 500, letterSpacing: 0, color: '#A5A5A5' }}>
            BILLED {isAnnual ? 'ANNUALLY' : 'MONTHLY'}
          </Typography>
          <Typography sx={{ fontSize: 70, fontWeight: 800, color: '#1A1A1A', lineHeight: 1.3 }}>
            <Box component="span" sx={{ fontSize: 30, fontWeight: 700, verticalAlign: 'super', paddingRight: 0.75 }}>$</Box>
            {price}
            <Typography component="span" sx={{ fontSize: 20, fontWeight: 500, color: '#D13C3C' }}>
              /{isAnnual ? 'year' : 'month'}
            </Typography>
          </Typography>
          <Box sx={{ mt: 1, backgroundColor: '#F5F5F5', borderRadius: 2, py: 0.75 }}>
            <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: '#D13C3C' }}>
              {isAnnual
                ? `Save $${pricing.annualSavings} vs. monthly — best value`
                : 'Less than $1 a day'}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 2.5, display: 'flex', justifyContent: 'center' }}>
          <Box sx={{ display: 'inline-flex', flexDirection: 'column', gap: 1.25 }}>
            {PLAN_CHECKLIST.map((item) => (
              <Box key={item} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box component="img" src={tickIcon} alt="" sx={{ width: 14, height: 12, flexShrink: 0 }} />
                <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#3E4954' }}>{item}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Button
          fullWidth
          onClick={() => onSubscribe('Premium', billingCycle)}
          disableElevation
          sx={{
            mt: 'auto',
            backgroundColor: '#27AE60',
            border: '1px solid #27AE60',
            color: '#fff',
            textTransform: 'none',
            borderRadius: '12px',
            py: 1.4,
            display: 'flex',
            flexDirection: 'column',
            '&:hover': { backgroundColor: '#177530' },
          }}
        >
          <Box component="span" sx={{ fontWeight: 700, fontSize: 18 }}>
            {/* Start My 14-Day Free Trial → */}
            SUBSCRIBE NOW
          </Box>
        </Button>
      </Box>
    </Box>
  );
};

export default PlanSelectionCard;
